export function Container({ as: Comp = 'div', className = '', children, ...props }) {
  return (
    <Comp
      className={[
        'mx-auto w-full max-w-6xl px-4 sm:px-6 lg:px-8',
        className,
      ].join(' ')}
      {...props}
    >
      {children}
    </Comp>
  );
}

